module.exports = __webpack_public_path__ + "static/media/pencil.eb3c8a6e.svg";